// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Irzu","col":"styles_col__2peAh"};